@if (unconfirmedTicket) {
  <div>
    <div class="row justify-content-start">
      <div class="col-7">
        <div class="card">
          <div class="card-header">Adicionar Requisito</div>
          <div class="card-body" [formGroup]="formRequirementTicket">
            <div class="row">
              <div class="col">
                <div class="form-group row">
                  <div class="col">
                    <patron-select
                      placeholder="Requisito"
                      [formGroup]="formRequirementTicket"
                      formControlName="requirement"
                      bindLabel="description"
                      orderBy="description"
                      label="Requisito"
                      modelName="requirements">
                    </patron-select>
                  </div>
                </div>
              </div>
              <div class="col-auto mt-6">
                @if (isDevCanWrite()) {
                  <patron-button (click)="addTicketReq()">
                    @if (loading) {
                      <i class="fa fa-spin fa-spinner"></i>
                    }
                    @if (!loading) {
                      <i class="pi pi-plus"></i>
                    }
                    Adicionar
                  </patron-button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (loading) {
      <div class="row mx-0">
        <div class="col text-muted text-center mt-2">
          <i class="fa fa-spin fa-spinner fa-5x"></i><br />
        </div>
      </div>
    }
    @if (!loading && (!ticketRequirements || !ticketRequirements.length)) {
      <div class="text-center border py-3 mt-3">Nenhum requisito adicionado</div>
    }
    @if (!loading && ticketRequirements) {
      <div>
        @for (ticketReq of ticketRequirements; track ticketReq; let i = $index) {
          <div class="row mx-0 py-3 border" [class.bg-light]="i % 2 != 0">
            <div class="col">
              <b>Requisito: </b>
              {{ ticketReq.requirement ? ticketReq.requirement.description : '' }}
            </div>
            <div class="col"><b>Usuário: </b> {{ ticketReq.user ? ticketReq.user.name : '' }}</div>
            <div class="col">
              <b>Complexidade: </b>
              <span class="h5">
                <patron-badge
                  [color]="convertComplexityColor(ticketReq.requirement!.complexity_color)"
                  class="ml-1">
                  {{ ticketReq.requirement ? ticketReq.requirement.complexity_label : '' }}
                </patron-badge>
              </span>
            </div>
            <div class="col-auto">
              <patron-button
                iconName="pi pi-trash"
                color="danger"
                class="ml-2"
                (click)="openDeleteConfirmationModal(i)">
              </patron-button>
            </div>
          </div>
        }
      </div>
    }
    <patron-modal
      title="Remover requisito"
      cancelButtonText="Cancelar"
      confirmButtonText="Deletar"
      [visible]="visibleModalDelete"
      (confirm)="delete()"
      (cancel)="cancelModal()">
      {{ deleteMessageModal }}
    </patron-modal>
  </div>
}

<div class="my-5 py-5"></div>
